import { Breadcrumbs as AriaBreadcrumbs, Breadcrumb } from 'react-aria-components';
import { Link } from 'react-router-dom';

export type BreadcrumbItem = {
  path: string;
  name: string;
};

type Props = {
  item: BreadcrumbItem[];
};

const Breadcrumbs = (props: Props) => {
  return (
    <AriaBreadcrumbs className="flex items-center">
      <Breadcrumb className="mx-2 flex items-center">
        <Link
          className="text-indigo-800"
          to={'/admin'}
        >
          ホーム
        </Link>
        <ArrowRight />
      </Breadcrumb>
      {props.item.map((item, index) =>
        index !== props.item.length - 1 ? (
          <>
            <Breadcrumb
              key={index}
              className="flex items-center"
            >
              <Link to={item.path}>{item.name}</Link>
              <ArrowRight />
            </Breadcrumb>
          </>
        ) : (
          <Breadcrumb
            key={index}
            className="flex items-center"
          >
            <span>{item.name}</span>
          </Breadcrumb>
        )
      )}
    </AriaBreadcrumbs>
  );
};

const ArrowRight = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_877_3908)">
        <path
          d="M4.50078 1.30005L3.80078 2.00005L7.80078 6.00005L3.80078 10L4.50078 10.7L9.20078 6.00005L4.50078 1.30005Z"
          fill="#1A1A1A"
        />
      </g>
      <defs>
        <clipPath id="clip0_877_3908">
          <rect
            width="12"
            height="12"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Breadcrumbs;
